import { render, staticRenderFns } from "./SpinningWheel.vue?vue&type=template&id=20f57f2f&scoped=true"
import script from "./SpinningWheel.vue?vue&type=script&lang=js"
export * from "./SpinningWheel.vue?vue&type=script&lang=js"
import style0 from "./SpinningWheel.vue?vue&type=style&index=0&id=20f57f2f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f57f2f",
  null
  
)

export default component.exports